import React from "react";
import styles from "../../../../styles/noEasyPay.module.scss";

function NoEasyPaySalesAgreement({ labels, msg="" }) {
  return (
    <div className={styles.mmaError + " mma--year-error row"}>
      <div className="col-12">
        <div className={`${styles.card} row mb-16 tru-mma-main-content-box`}>
          <div className="col-12 gfw-3 p-30 text-center text-md-left tru-mma-main-content">
            <div className="align-items-center row">
              <div className="col-md-2">
                <img
                  src="/images/MyAccount/Icons/error-notification-icon.png"
                  className="img-fluid"
                  alt="Error Notification"
                />
              </div>
              <div className="col-md-10">
                <span className="d-block gfs-24 gfs-lg-30 glh-1_2 mb-10">
                  <span
                    className="d-block gfs-24 gfs-lg-30 glh-1_2 mb-10"
                    dangerouslySetInnerHTML={{
                      __html: msg === "" ? labels.epnoserviceenrolled : msg
                    }}
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoEasyPaySalesAgreement;
